interface CashCreditPayment {
  creditFromPreviousOrder?: number | null;
  dueAtOrder?: number | null;
}

interface CashCreditTradeIn {
  status?: string | null;
}

export const deriveCashCreditBalance = (
  payment?: CashCreditPayment | null,
  tradeIn?: CashCreditTradeIn | null
): number | null => {
  const hasPreviousOrderCredit = (payment?.creditFromPreviousOrder ?? 0) > 0;
  const hasAppliedTradeIn = tradeIn?.status?.toLowerCase() === 'applied';
  const dueAtOrder = payment?.dueAtOrder;

  return (hasPreviousOrderCredit || hasAppliedTradeIn) && dueAtOrder != null ? dueAtOrder : null;
};
